export enum Service {
  LOGIN = 'login',
  NOTIFICATION = 'notification',
  APPROVAL_CENTER = 'approval_center',
}